if (!customElements.get('app-bar')) {
  class AppBar extends HTMLElement {
    constructor() {
      super();

      this.appStoreButton = this.querySelector('[data-button="app-store-button"]');
      this.googlePlayButton = this.querySelector('[data-button="google-play-button"]');
      this.buttonClose = this.querySelector('[data-close]');
    }
    
    connectedCallback() {
      if (this.getCookie('app-bar-closed')) return;

      const mobileOperatingSystem = this.getMobileOperatingSystem();

      if (mobileOperatingSystem === 'Android') {
        this.appStoreButton?.remove();
      } else if (mobileOperatingSystem === 'iOS') {
        this.googlePlayButton?.remove();
      }

      this.classList.add('is-visible');

      this.buttonClose.addEventListener('click', (e) => {
        e.preventDefault();

        this.classList.remove('is-visible');
        this.setCookie('app-bar-closed', 'true', 30);
      });

      this.appStoreButton.addEventListener('click', () => {
        this.setCookie('app-bar-closed', 'true', 30);
      });
    }

    getMobileOperatingSystem() {
      const userAgent = navigator.userAgent || window.opera;

      if (/android/i.test(userAgent)) {
        return 'Android';
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }

      return 'Unknown';
    }

    setCookie (name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    };

    getCookie (name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }

  customElements.define('app-bar', AppBar);
}
